import cognitoConfig from '../config/cognito';
import { http } from '../http';

export type LoginResponse = {
	email: string;
	user_id: string;
	session: string;
	method: string
}
export const login = async (email: string) => {
	const signupResponse = await http.post<LoginResponse>('auth/login', { email, client_id: cognitoConfig.cognitoClient }, true);
	return signupResponse
}
